<template>
  <div>
    <el-empty v-if="!materials.length" description="暂无数据"/>
    <div v-else class="material-list">
      <div v-for="(group, type) in groupedMaterials" :key="type" class="material-item">
        <h4>{{ getMaterialTypeName(type) }}</h4>
        <div class="file-container">
          <div v-for="(path, index) in group" :key="index">
            <el-image
                class="file-image"
                v-if="isImage(path)"
                :src="path"
                :preview-src-list="[path]"
                fit="scale-down"
            />
            <div v-else class="file-item" @mouseover="showButtons = true" @mouseleave="showButtons = false">
              <span>{{ getFileName(path) }}.{{ getSuffix(path) }}</span>
              <div v-if="showButtons" class="file-buttons">
                <el-button v-if="isPdf" type="text" @click="previewFile(path)">预览</el-button>
                <el-button type="text" @click="downloadFile(path)">下载</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let number;
export default {
  name: "OrderMaterial",
  props: {
    materials: {
      type: Array,
      required: true,
      default: () => []
    },
    model: {
      type: number,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      showButtons: false
    };
  },
  computed: {
    groupedMaterials() {
      return this.materials.reduce((acc, material) => {
        if (!acc[material.type]) {
          acc[material.type] = [];
        }
        acc[material.type] = acc[material.type].concat(material.path.split(','));
        return acc;
      }, {});
    }
  },
  methods: {
    getMaterialTypeName(type) {
      if (this.model === 1){
        return this.$dict.nameOf('order_material_type', type);
      }else if(this.model === 2){
        return this.$dict.nameOf('order_material_compact_type', type);
      }else if(this.model === 3){
        return "车辆登记证书照片";
      }
    },
    isImage(path) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
      return imageExtensions.includes(this.getSuffix(path).toLowerCase());
    },
    isPdf(path) {
      return this.getSuffix(path).toLowerCase() === 'pdf';
    },
    getFileName(path) {
      return path.split('/').pop().split('.').slice(0, -1).join('.');
    },
    getSuffix(path) {
      return path.split('.').pop();
    },
    previewFile(path) {
      window.open(path, '_blank');
    },
    downloadFile(path) {
      const link = document.createElement('a');
      link.href = path;
      link.download = this.getFileName(path) + '.' + this.getSuffix(path);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped>
.material-list {
  /*  display: flex;
    flex-wrap: wrap;*/
}

.material-item {
  box-sizing: border-box;
  min-width: 200px;
  margin: 10px;
}

.file-item {
  position: relative;
  margin: 10px;
  padding: 10px;
  border-radius: 4px;
  display: inline-block;
}

.file-image {
  max-width: 200px;
  max-height: 200px;
  margin: 5px;
  position: relative;
  border-radius: 4px;
  display: inline-block;
}

.file-buttons {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  padding: 5px;
}

.file-container {
  display: flex;
  flex-wrap: wrap;
}
</style>
